import AntdProvider from 'providers/AntdProvider';
import ErrorBoundary from 'providers/ErrorBoundary';
import { WSProvider } from 'services/ws/context';

import Router from '../pages';

export const App = () => {
  return (
    <WSProvider>
      <AntdProvider>
        <ErrorBoundary>
          <Router />
        </ErrorBoundary>
      </AntdProvider>
    </WSProvider>
  );
};
